import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { bool, func } from 'prop-types';
import { useHistory } from 'react-router-dom';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import {
  AspectRatioWrapper,
  LayoutSingleColumn,
  NamedLink,
  Page,
  PrimaryButton,
} from '../../components';
import { FormattedMessage, injectIntl, useIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useConfiguration } from '../../context/configurationContext';
import { propTypes } from '../../util/types';
import { ensureOwnListing } from '../../util/data';
import { createSlug } from '../../util/urlHelpers';
import { sortByListSortAttribute } from '../../util/sortByListSortAttribute';

import logoImg from './media/rarewaters_wordmarkonly_dark 1.svg';
import bannerDetailImg from './media/Fly-fishing-access..svg';
import imgSection from './media/imageSectionV2.png';
import umpquaImg from './brand/umpqua.svg';
import rossReelsImg from './brand/ross-reels.svg';
import riverSmithImg from './brand/river-smith.svg';
import troutUnlimitedImg from './brand/trout-unlimited.svg';
import airfloImg from './brand/airflo.svg';
import abelImg from './brand/abel.svg';
import troutRoutesImg from './brand/trout-routes.svg';
import arborImg from './brand/arbor.svg';
import goldenFlyShopImg from './brand/golden-fly-shop.svg';
import hookersImg from './brand/hookers.svg';
import membershipWhiteTitle from './media/membershipWhiteTitle.png';
import membershipColoredTitle from './media/membershipColoredTitle.png';

import css from './SeasonPassPage.module.scss';
import FrequentlyAskedQuestionsJoinUs from '../../components/FrequentlyAskedQuestionsJoinUs/FrequentlyAskedQuestionsJoinUs';

const SeasonPassPageComponent = props => {
  const {
    scrollingDisabled,
    seasonPassList,
    seasonPassListInProgress,
    seasonPassListError,
    callSetInitialValues,
    onInitializeCardPaymentData,
    currentUser,
    seasonPasses,
  } = props;

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'SeasonPassPage.pageTitle' });
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const config = useConfiguration();
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    if (window.innerWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const brandData = [
    {
      brandImg: umpquaImg,
    },
    {
      brandImg: rossReelsImg,
    },
    {
      brandImg: riverSmithImg,
    },
    {
      brandImg: troutUnlimitedImg,
    },
    {
      brandImg: airfloImg,
    },
    {
      brandImg: abelImg,
    },
    {
      brandImg: troutRoutesImg,
    },
    {
      brandImg: arborImg,
    },
    {
      brandImg: goldenFlyShopImg,
    },
    {
      brandImg: hookersImg,
    },
  ];

  const unescape = {
    '\uff1e': '>',
    '\uff1c': '<',
  };

  const spItem = {
    index: 0,
    component: (
      <div className={`${css.seasonPassItem} ${css.oneTimeUseItem}`}>
        <div className={`${css.seasonPassItemLimited} ${css.seasonPassItemLimitedMobile}`}>
          <p>
            Limited to 500 Season Pass Memberships in 2025. Members will have access to ~100 miles
            of water, and we'll continue to add new properties every month! Grab yours before they
            sell out!!
          </p>
        </div>
        <div className={css.oneTimeUseContainer}>
          <div>
            <div className={css.oneTimeUseTitle}>TRY BEFORE</div>
            <div className={css.oneTimeUseTitle}>YOU BUY</div>
            <div className={css.oneTimeUseDescription}>ONE TIME USE PER ANGLER</div>
          </div>
        </div>

        <p className={css.seasonPassDescription}>
          Available <b>one time only</b> to new customers -<br /> Experience a taste of Rarewaters
          before
          <br /> committing to a Season Pass Membership
        </p>

        <div className={css.itemContent}>
          <p className={css.priceTwo}>$175/angler</p>
          <p className={css.takesAndFees}>(plus processing and service fee)</p>
        </div>

        <div className={css.itemContentDetail}>
          <p style={{ fontSize: '24px', fontWeight: 900, lineHeight: '30px' }}>DETAILS</p>
          <p style={{ fontSize: '18px', fontWeight: 800, lineHeight: '25px', paddingTop: '20px' }}>
            Property Access
          </p>
          <p style={{ fontSize: '18px', fontWeight: 600, lineHeight: '25px', paddingTop: '4px' }}>
            $175 per day per angler
          </p>
          <p style={{ fontSize: '18px', fontWeight: 800, lineHeight: '25px', paddingTop: '20px' }}>
            Blackout Dates May Apply
          </p>
          <p style={{ fontSize: '18px', fontWeight: 600, lineHeight: '25px', paddingTop: '4px' }}>
            Season Pass holders have priority booking
          </p>
          <p style={{ fontSize: '18px', fontWeight: 800, lineHeight: '25px', paddingTop: '20px' }}>
            Pick a Date that Works for You
          </p>
          <p style={{ fontSize: '18px', fontWeight: 600, lineHeight: '25px', paddingTop: '4px' }}>
            Individual property details vary, browse our
            <br /> locations and book a date that works for you
          </p>
          <p style={{ fontSize: '18px', fontWeight: 800, lineHeight: '25px', paddingTop: '20px' }}>
            Experience RareWaters
          </p>
          <p style={{ fontSize: '18px', fontWeight: 600, lineHeight: '25px', paddingTop: '4px' }}>
            Before buying a season pass, experience
            <br /> the benefits of booking private ranches
            <br /> through RareWaters
          </p>
          <p style={{ fontSize: '18px', fontWeight: 800, lineHeight: '25px', paddingTop: '20px' }}>
            Camping Available at Select Locations
          </p>
          <p style={{ fontSize: '18px', fontWeight: 600, lineHeight: '25px', paddingTop: '4px' }}>
            Starting at $50/vehicle per booking
          </p>
        </div>

        <NamedLink className={css.itemRouter} name="SearchPage">
          <FormattedMessage id="SeasonPassPage.bookNow" />
        </NamedLink>
      </div>
    ),
  };
  const sortedSeasonPassList = sortByListSortAttribute(seasonPassList);

  // const seasonPassRenderer = [{ ...spItem }];
  const seasonPassRenderer = [];
  sortedSeasonPassList?.forEach((item, index) => {
    seasonPassRenderer.push({
      index: index + 1,
      component: (
        <SeasonPassItem
          callSetInitialValues={callSetInitialValues}
          onInitializeCardPaymentData={onInitializeCardPaymentData}
          unescape={unescape}
          key={index}
          item={item}
          currentUser={currentUser}
          routeConfiguration={routeConfiguration}
          history={history}
          config={config}
        />
      ),
    });
  });

  const faqItems = [
    {
      question: 'How does it work?',
      answer: (
        <span>
          All members have access to book any of our available properties at any time during the
          calendar year. Simply log in to your account, pick the day and property you’d like to
          fish, and book! Our system will recognize you as a member and take care of your booking at
          no additional cost. All bookings are first come, first serve. We kindly request members
          have no more than seven (7) bookings scheduled at a time.
          <br />
          <br />
        </span>
      ),
    },
    {
      question: 'Does membership expire?',
      answer: (
        <span>
          Memberships are valid for the full calendar year. All current members have the right to
          renew their membership the following year so they don’t lose their spot to a new customer.
          <br />
          <br />
        </span>
      ),
    },
    {
      question: 'How do I receive my additional perks included with my membership?',
      answer: (
        <span>
          After you join, an email will be sent to you with the details of your membership including
          next steps, perks, etc. Kindly review this email and reach out to a member of our team if
          you have any questions. We can be reached via email at support@rarewaters.com or phone at
          720-504-4881.
          <br />
          <br />
        </span>
      ),
    },
    {
      question: 'Can a family member or friend use my membership?',
      answer: (
        <span>
          No. All memberships are non-transferable and can only be used by the purchaser. Family
          members and friends over the age of 13 must have their own membership. Abuse of this
          policy is strictly prohibited and grounds for permanent removal from RareWaters with no
          refund.
          <br />
          <br />
          Members can purchase buddy passes if they want to bring friends and family along. If
          you’re bringing guests, the booking system will automatically apply a daily access fee for
          guests during checkout.
          <br />
          <br />
          If members are caught sharing their access with family members and/or friends, their
          membership will be terminated immediately and no refund will be issued.
          <br />
          <br />
        </span>
      ),
    },
    {
      question: 'How much does it cost to be a member at RareWaters?',
      answer: (
        <span>
          <p>
            The RareWaters Season Pass Membership is $2,500 plus service fees, totaling{' '}
            <strong>$2,787.50</strong> for the full year. This includes:
          </p>
          <ul className={css.bulletList}>
            <li>
              <p>
                <strong>Unlimited access</strong> to all RareWaters properties across the country
                (first come/first serve)
              </p>
            </li>
            <li>
              <p>
                <strong>No blackout dates</strong> and <strong>no rod fees</strong> for the member
              </p>
            </li>
            <li>
              <p>
                <strong>Unlimited buddy passes</strong> at{' '}
                <strong>$140 per guest, per booking</strong>
              </p>
            </li>
            <li>
              <p>
                <strong>Optional camping access</strong> available for an additional fee
              </p>
            </li>
            <li>
              <p>
                <strong>Free access</strong> for non-angling spouses and children under 13
              </p>
            </li>
          </ul>
          <p>
            It’s the perfect way to enjoy a full season of private fly fishing with plenty of
            flexibility and room to bring friends along.
          </p>
        </span>
      ),
    },
  ];

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        className={css.layoutColumStyle}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <section className={css.bannerSection}>
            <div>
              <img src={logoImg} alt="Rare Waters" className={css.logoImg} />
              <img src={membershipWhiteTitle} alt="Season Passes" className={css.bannerTextImg} />
              <img
                src={membershipWhiteTitle}
                alt="Season Passes"
                className={css.bannerTextMobileImg}
              />
              <img src={bannerDetailImg} alt="Fly-fishing access" className={css.bannerDetailImg} />
            </div>
          </section>
          <section className={css.seasonPassCardsSection}>
            <div>
              <div className={css.seasonPassItems}>
                {seasonPassRenderer
                  .sort((a, b) => b.index - a.index)
                  .map(render => render.component)}
              </div>
            </div>
          </section>
          {/* <section className={css.brandSection}>
            <div>
              <p className={css.brandTitle}>RareWaters’ Brand Partners</p>
              <div className={css.imagesContainer}>
                {brandData.map((brand, index) => (
                  <img
                    key={index}
                    src={brand.brandImg}
                    alt={`Brand ${index + 1}`}
                    width={index === 6 ? 130 : undefined}
                  />
                ))}
              </div>
            </div>
          </section> */}
          <section className={css.imgSection}>
            <div className={css.imageWrapper}>
              <img src={imgSection} alt="Rare Waters" />
            </div>
          </section>
          <section className={css.faqSection}>
            <FrequentlyAskedQuestionsJoinUs
              items={faqItems}
              backgroundColorCollapse={'white'}
              backgroundColor={'white'}
            />
          </section>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const SeasonPassItem = ({
  item,
  unescape,
  callSetInitialValues,
  onInitializeCardPaymentData,
  currentUser,
  routeConfiguration,
  history,
  config,
}) => {
  const { title, publicData, description } = item?.attributes;
  const handleRouter = item => {
    const quantityRaw = 1;
    const deliveryMethod = 'shipping';
    const quantity = Number.parseInt(quantityRaw, 10);
    const quantityMaybe = Number.isInteger(quantity) ? { quantity } : { quantity: 1 };

    const deliveryMethodMaybe = deliveryMethod
      ? { deliveryMethod }
      : { deliveryMethod: 'shipping' };
    const updatedInitialValues = {
      listing: item,
      orderData: {
        ...quantityMaybe,
        ...deliveryMethodMaybe,
      },
      confirmPaymentError: null,
    };
    const saveToSessionStorage = !currentUser;
    const { setInitialValues } = findRouteByRouteName('CheckoutPageV1', routeConfiguration);
    callSetInitialValues(setInitialValues, updatedInitialValues, saveToSessionStorage);
    onInitializeCardPaymentData();
    history.push(
      createResourceLocatorString(
        'CheckoutPageV1',
        routeConfiguration,
        { id: item?.id?.uuid, slug: createSlug(item?.attributes?.title) },
        {}
      )
    );
  };
  const bestValueListing = publicData?.isBestValue;
  const currentListing = ensureOwnListing(item);
  const isOwnListing = currentListing?.author?.id?.uuid === currentUser?.id?.uuid;
  const firstImage = item?.images && item?.images?.length > 0 ? item?.images[0] : null;
  const aspectWidth = 1;
  const aspectHeight = 1;
  const variantPrefix = 'scaled';

  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(img => img.startsWith(variantPrefix))
    : [];

  const redirectToMembershipApplicationPage = () => {
    history.push('/membership-application');
  };

  return (
    <div className={`${css.seasonPassItem} ${bestValueListing && css.seasonPassItemBorder}`}>
      <div className={css.seasonPassItemLimited}>
        <p>
          Limited memberships available. <br className={css.seasonPassLimitedBreak} />
          Join now to reserve your spot!!
        </p>
      </div>
      <div className={css.imgContainer}>
        <div>
          <AspectRatioWrapper
            width={aspectWidth}
            height={aspectHeight}
            className={css.aspectWrapper}
          >
            <img src={membershipColoredTitle} alt={title} className={css.rootForImage} />
          </AspectRatioWrapper>
          {/* <div className={`${css.seasonPassTitle} ${css.seasonPassTitleDesktop}`}>{title}</div>
          <div className={`${css.seasonPassTitle} ${css.seasonPassTitleMobile}`}>SEASON PASS</div> */}
          <div className={`${css.seasonPassTitle} ${css.seasonPassTitleDesktop}`}>DETAILS</div>
          <div className={`${css.seasonPassTitle} ${css.seasonPassTitleMobile}`}>DETAILS</div>
        </div>
      </div>

      <p className={css.seasonPassDescription}>
        {/* Enjoy <b>unlimited fishing access</b> to all RareWaters
        <br /> properties for the 2025 calendar year! */}
        Enjoy unlimited do-it-yourself fly fishing access to our entire{' '}
        <br className={css.seasonPassDescriptionBreak} /> portfolio of properties
      </p>

      <div className={css.itemContent}>
        {/* <p className={`${css.priceTwo} ${css.lineThrough}`}>{`$2500/year`}</p> */}
        <p className={css.priceTwo}>$2,500 per year</p>
        {/* <p className={css.earlyBirdPricing}>$2250/year with PRESEASON pricing!</p> */}
        <p className={css.takesAndFees}>(plus processing and service fee)</p>
      </div>

      <div className={css.itemContentDetail}>
        <p className={css.mainTitle}>PERKS</p>
        <p className={css.boldedParagraph}>Unlimited fly fishing access</p>
        <p className={css.boldedParagraph}>No blackout dates</p>
        <p className={css.boldedParagraph}>
          Receive exclusive invitations to monthly member community events
        </p>

        <p className={css.boldedParagraph}>Invite your family</p>
        <p className={css.unboldedParagraph}>
          Non-angling spouses and children under the age of 13 are free
        </p>

        <p className={css.boldedParagraph}>Unlimited buddy passes</p>
        <p className={css.unboldedParagraph}>
          Invite your family, friends and colleagues at 20% off our standard daily rate
        </p>

        <p className={css.boldedParagraph}>15% off gear at select fly shops</p>
        <p className={css.unboldedParagraph}>
          Arbor Anglers, Golden Fly Shop, and Hookers (rods and reels excluded)
        </p>

        <p className={css.boldedParagraph}>Exclusive Discounts with Gravity Haus</p>
        <p className={css.unboldedParagraph}>
          15% off of lodging: Big Sky, Breckenridge, Moab, Steamboat, Vail, Truckee, Winter Park.
        </p>
        <p className={css.unboldedParagraph}>20% off Gravity Haus Membership</p>

        <p className={css.boldedParagraph}>Camping available at select locations</p>
        <p className={css.unboldedParagraph}>Camping starts at $50 per vehicle per day</p>

        <p className={css.boldedParagraph}>Free Trout Unlimited membership</p>
        <p className={css.unboldedParagraph}>$35 value</p>

        <p className={css.boldedParagraph}>Free TroutRoutes subscription</p>
        <p className={css.unboldedParagraph}>$100 value</p>
      </div>

      <PrimaryButton
        type="button"
        onClick={() => {
          handleRouter(item);
          // redirectToMembershipApplicationPage();
        }}
        className={css.itemRouter}
        disabled={isOwnListing ? true : false}
      >
        <FormattedMessage id="SeasonPassPage.joinNowButton" />
        {/* <FormattedMessage id="SeasonPassPage.applyNowButton" /> */}
      </PrimaryButton>
    </div>
  );
};

SeasonPassPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  callSetInitialValues: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {
  const { seasonPassList, seasonPassListInProgress, seasonPassListError } = state.SeasonPassPage;
  const { currentUser } = state.user;
  const { seasonPasses } = state.seasonPass;

  return {
    seasonPassList,
    seasonPassListInProgress,
    seasonPassListError,
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    seasonPasses,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
    onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  };
};

const SeasonPassPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(SeasonPassPageComponent);

export default SeasonPassPage;
